import { memo, useCallback, useState } from "react";
import "@visioni/a3s-ui/theme";
import { StyleSheet } from "react-native-unistyles";
import { View } from "@visioni/a3s-ui/components";
import { AccessCard } from "../AccessCard";
import { AccessListHeader } from "../AccessListHeader";

export type SiteAccessListSite = {
  id: string;
  name: string;
  snapshotUrl?: string | null;
};

export type SitePermission = {
  siteId: string;
  role: "manager" | "viewer";
};

export type SiteAccessListProps = {
  sites: SiteAccessListSite[];
  selected: Map<string, "manager" | "viewer">;
  onToggle: (id: string) => void;
  onRoleChange: (id: string, role: "manager" | "viewer") => void;
};

export const SiteAccessList = memo(({ sites, selected, onToggle, onRoleChange }: SiteAccessListProps) => {
  const [collapsed, setCollapsed] = useState(false);

  const handleToggleCollapsed = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  return (
    <View style={styles.container}>
      <AccessListHeader
        title="Sites"
        selectedCount={selected.size}
        totalCount={sites.length}
        collapsed={collapsed}
        onToggle={handleToggleCollapsed}
      />
      {!collapsed && (
        <View style={styles.list}>
          {sites.map((site) => (
            <AccessCard
              key={site.id}
              id={site.id}
              name={site.name}
              thumbnailUrl={site.snapshotUrl}
              selected={selected.has(site.id)}
              role={selected.get(site.id) ?? "viewer"}
              onToggle={onToggle}
              onRoleChange={onRoleChange}
            />
          ))}
        </View>
      )}
    </View>
  );
});

const styles = StyleSheet.create((theme) => ({
  container: {
    gap: theme.spacing.sm,
    borderWidth: 1,
    borderColor: theme.colors.borderCard,
    borderRadius: theme.spacing.md,
    padding: theme.spacing.md,
  },
  list: {
    gap: theme.spacing.sm,
  },
}));
